import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, Text, View, TextInput as RNTextInput } from 'react-native';

import { ACTION, ITEM, SCREEN, SCREEN_TYPE } from '../../constants/mixpanel';

import {
  useConfirmResetEmailMutation,
  useDoResetEmailMutation,
  useConsumerQuery,
} from 'apollo/queries/autogenerate/hooks';
import CodeInput from 'shared/modules/common/components/atoms/CodeInput';
import OTPTimer from 'shared/modules/common/components/organisms/OTPTimer';
import Mixpanel from 'shared/vendor/Mixpanel';

const PLEASE_CHECK_EMAIL_EVENT = `${SCREEN.PLEASE_CHECK_EMAIL} - ${ACTION.PAGE_VIEW}`;

const EditUserEmailEnterNewEmailOTP = (props: {
  email: string;
  submitEmailOTPStage: () => void;
  onOTPFulfill: () => void;
}) => {
  const [confirmResetMutation] = useConfirmResetEmailMutation();
  const [doResetMutation] = useDoResetEmailMutation();
  const { refetch } = useConsumerQuery({ fetchPolicy: 'cache-only' });

  const [smsOtp, setSmsOtp] = useState('');
  const [showError, setShowError] = useState(false);
  const codeInputRef = useRef<RNTextInput>(null);

  useEffect(() => {
    Mixpanel.trackEvent(PLEASE_CHECK_EMAIL_EVENT, {
      'Screen Type': SCREEN_TYPE.EMAIL_RESET,
    });

    codeInputRef.current?.focus();
  }, []);

  // Sends an OTP code to the email address the user want to become a new email
  // So this can be invoked to request a new OTP
  const submitSMSOTP = async (code?: string) => {
    setShowError(false);

    try {
      await confirmResetMutation({
        variables: {
          otp: code || smsOtp,
        },
      });

      if (code) {
        setSmsOtp(code);
        props.submitEmailOTPStage();
      }
    } catch (err) {
      setShowError(true);
    }
  };

  // If the correct OTP is submitted, this permanently updates the user's email address
  // Cannot be used to request a new OTP
  const submitEmailOTP = async (code: string) => {
    setShowError(false);

    // track event of submission
    Mixpanel.trackEvent(`${SCREEN.EMAIL_RESET_FORM} - ${ACTION.CLICK}`, {
      Item: ITEM.SUBMIT,
    });

    try {
      await doResetMutation({
        variables: {
          otp: code,
        },
      });

      refetch();
      props.onOTPFulfill();
    } catch (err) {
      setShowError(true);
    }
  };

  return (
    <>
      <View style={style.root}>
        <Text style={style.title}>
          メールアドレスに送信された4桁の認証コードを入力してください。
        </Text>
        <View style={style.spacer} />
        <View style={style.otp}>
          <CodeInput
            onFulFill={submitEmailOTP}
            style={style.codeField}
            errorMessage="認証コードが違います"
            showError={showError}
            id="edit-user-email-code-field"
            ref={codeInputRef}
          />
        </View>
      </View>
      <OTPTimer sentToLabel="メール" onPress={submitSMSOTP} />
    </>
  );
};

const style = StyleSheet.create({
  root: {
    flexGrow: 1,
  },
  otp: {
    alignItems: 'center',
  },
  codeField: {
    width: 288,
  },
  spacer: {
    marginBottom: 24,
  },
  title: {
    fontSize: 16,
    fontWeight: '300',
    lineHeight: 24,
    alignSelf: 'center',
  },
});

export default EditUserEmailEnterNewEmailOTP;
